import ajax from "@/common/ajax";
const request = ajax;
const verCode = (data) => request.get("/api/v1/bionexis/verify", data);
const contactInfo = (data) => request.get("/api/v1/bionexis/contact", data);
export { verCode, contactInfo };
